//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {smartUpload} from "smart-filer";
import vueFilter from "@/common/filter/vuefilter.js";

export default {
  name: "confirmSettlement",
  components: {
    smartUpload
  },
  data() {
    return {
      accepts: 'text/plain,image/*,application/vnd.ms-excel,application/msword,application/pdf',
      mappingData: {
        processId: null, //"3e9ff7bc-1c77-4bab-b07d-740c3b01f170",
        relatedId: null //,"9d43c3d8-2617-4f6b-9e5c-bf912a61fdc7",
        // relatedType: "Settle",
        // catalog: "水单"
      },
      filterData: {
        relatedId: null, //"9d43c3d8-2617-4f6b-9e5c-bf912a61fdc7",
        // relatedId:[ "54c0fa61-93ca-41db-a280-3a2df31da86e","a6dce0a3-097b-4e1d-94a3-6632399f9e0a"],
        catalog: "水单"
      },
      uploader: {
        bucket: "SmartEvent",
        filterData: {
          processId: this.iStorage.get('eventData').proposalId,
          relatedId: "",
          catalog: "水单"
        },
        // mappingData: {
        //   processId: "",
        //   relatedId: "",
        //   catalog: "iSmartJob"
        // },

        readOnly: true
      },
      uploader2: {
        bucket: "SmartEvent",
        filterData: {
          processId: this.iStorage.get('eventData').proposalId,
          relatedId: "",
          catalog: "支付凭证"
        },
        // mappingData: {
        //   processId: "",
        //   relatedId: "",
        //   catalog: "iSmartJob"
        // },
        readOnly: true
      },
      host: "",
      show: false,
      returnReason: "",
      initData: {},
      isLoading: false,
      proposalId: "",
      isShowExpenseItems: false,
      isShowAdvances: false,
      expenseList: [],
      item: {}
    };
  },
  created() {
    if (this.iStorage.get('eventData').proposalId) {
      this.proposalId = this.iStorage.get('eventData').proposalId;
    }
    //  this.proposalId="8c4860a1-af6a-464d-b3a6-800616105e81";
    // this.proposalId = "65128cee-7815-4bfb-add0-916c3fc1ac00";
    this.getInitData();
    // 监听安卓返回键
    this.setRouteListeners("confirmSettlementGoBack");
    this.$root.$eventHub.$on("confirmSettlementGoBack", data => {
      this.confirmSettlementGoBack();
      this.$root.$eventHub.$off("confirmSettlementGoBack"); //解绑当前监听，否则下轮监听还会持续叠加
    });
  },
  mounted() {
  },
  methods: {
    confirmSettlementGoBack() {
      this.removeRouteListeners("confirmSettlementGoBack");
      //刷新页面
      var sendData = JSON.stringify({handle: "reload_event_detail"});
      this.iJsBridge.call({
        method: "SMGeneral.setResultToNative",
        postData: sendData
      });
      this.iJsBridge.close();
    },
    onClickLeft() {
      //刷新页面
      var sendData = JSON.stringify({handle: "reload_event_detail"});
      this.iJsBridge.call({
        method: "SMGeneral.setResultToNative",
        postData: sendData
      });
      this.iJsBridge.close();
    },
    async getInitData() {
      let params = {
        Filters: {
          ProposalId: this.proposalId
        }
      };
      const res = await this.axios.post(this.api.QueryCostDetails, params);
      if (res && res.success) {
        this.isLoading = false;
        this.initData = res.content;
        // alert(this.initData.amount);
        this.initData.items.forEach((item, index) => {
          item.dtStart = vueFilter.formatDate(item.dtStart, "yyyy/MM/dd");
          item.dtEnd = vueFilter.formatDate(item.dtEnd, "yyyy/MM/dd");
        });
        let expenseList = this.initData.expenseList;
        this.initData.allExpensePrice = 0;
        for (var i = 0; i < expenseList.length; i++) {
          expenseList[i].expenseData = JSON.parse(expenseList[i].expenseData);
          expenseList[i].expenseData.mappingData = {
            processId: expenseList[i].proposalId,
            relatedId: expenseList[i].expenseData.payItemId
          }

          expenseList[i].expenseData.filterData = {
            processId: expenseList[i].proposalId,
            relatedId: expenseList[i].expenseData.payItemId //"9d43c3d8-2617-4f6b-9e5c-bf912a61fdc7",
          }

          this.initData.allExpensePrice += expenseList[i].amount;
        }
        console.log(expenseList)
        this.expenseList = expenseList;
      }
    },
    // backMethod() {
    //   this.show = true;
    // },
    async beforeClose(action, done) {
      // if (action === "confirm") {
      //   let res = await this.axios.post(this.api.ExpenseTask, {
      //     ProposalId: this.proposalId,
      //     OperationCode: "goback",
      //     Descr: this.returnReason
      //   });
      //   if (res.success) {
      //     this.$toast("退回成功");
      //     //刷新页面
      //     var sendData = JSON.stringify({handle: "reload_event_detail"});
      //     this.iJsBridge.call({
      //       method: "SMGeneral.setResultToNative",
      //       postData: sendData
      //     });
      //     //退出站点
      //     this.iJsBridge.close();
      //     // this.getInitData();
      //     done();
      //   } else {
      //     // this.$toast('退回失败');
      //   }
      // } else {
      //   done();
      // }
      if (action === "confirm") {
        this.item.reason = this.returnReason;
        this.doConfirm();
        this.iJsBridge.close();
        done();
      }else {
        done();
      }
    },
    newConfirmSettlement(item) {
      this.returnReason = '';
      this.$dialog
        .confirm({
          title: "再次确认",
          message: "您是否" + item.actName + "?"
        })
        .then(() => {
          this.item = item;
          if (item.actName != '退回') {
            this.doConfirm();
          } else {
            this.show = true;
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    async doConfirm() {
      let item = this.item;
      let res = await this.axios.post(this.api.ProcessTask, {
        taskId: item.taskId,
        nodeId: item.nodeId,
        actionId: item.actionId,
        processId: item.processId,
        reason: item.reason || '',
      });
      if (res.success) {
        //this.$toast("已成功确认结算");
        // this.getInitData();
        //刷新页面
        var sendData = JSON.stringify({handle: "reload_event_detail"});
        this.iJsBridge.call({
          method: "SMGeneral.setResultToNative",
          postData: sendData
        });
        //关闭站点
        this.iJsBridge.close();
      } else {
        //  this.$toast('确认结算失败');
      }
    },
    // confirmSettlement(mark, markTxt) {
    //   if (mark == "goback") {
    //     this.show = true;
    //   } else {
    //     this.$dialog
    //       .confirm({
    //         title: "再次确认",
    //         message: "您是否" + markTxt + "?"
    //       })
    //       .then(async () => {
    //         let res = await this.axios.post(this.api.ExpenseTask, {
    //           ProposalId: this.proposalId,
    //           OperationCode: "confirm"
    //         });
    //         if (res.success) {
    //           //this.$toast("已成功确认结算");
    //           // this.getInitData();
    //           //刷新页面
    //           var sendData = JSON.stringify({ handle: "reload_event_detail" });
    //           this.iJsBridge.call({
    //             method: "SMGeneral.setResultToNative",
    //             postData: sendData
    //           });
    //           //关闭站点
    //           this.iJsBridge.close();
    //         } else {
    //           //  this.$toast('确认结算失败');
    //         }
    //       })
    //       .catch(() => {
    //         // on cancel
    //       });
    //   }
    // },
    //下拉刷新
    onRefresh() {
      this.getInitData();
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/confirmSettlement.vue